import type { categoryColors } from "@plasma/data/categories";

/* Category card colors mapped to design system semantic colors */
export const categoryCardColors: Record<
  (typeof categoryColors)[number],
  string
> = {
  white: "bg-background ring-3 ring-border",
  gray: "bg-muted",
  red: "bg-destructive/10",
  orange: "bg-warning/10",
  amber: "bg-warning/15",
  yellow: "bg-warning/20",
  lime: "bg-success/10",
  green: "bg-success/15",
  emerald: "bg-success/20",
  teal: "bg-info/15",
  cyan: "bg-info/10",
  sky: "bg-sky-100",
  blue: "bg-sky-200",
  indigo: "bg-sky-300",
  violet: "bg-sky-400",
  purple: "bg-sky-400",
  fuchsia: "bg-sky-300",
  pink: "bg-sky-200",
};
